/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Compose {
  /**
   * Compose a new function from two given functions.
   *
   * @public
   * @function f1.compose
   * @param f the second function to be called
   * @param g the first function to be called
   * @param v the value to the g which is passed to f which is returned
   * @example
   *
   * ```ts
   * f1.compose(f, g, 1) === f(g(1));
   * ```
   */
  <V, Y, F extends Function, G extends Function>(f: F, g: G, value: V): Y;
  <V, Y, F extends Function, G extends Function>(f: F, g: G): (value: V) => Y;
}

/**
 * @see Compose
 */
export default <V, Y, F extends Function, G extends Function>(f: F, g: G, value: V): Y => f(g(value));
